import React from "react";

export const Image = ({ source, className, onClick, alt, ...props}) => {
  return <img src={source} alt={alt} className={className} onClick={onClick} {...props} />;
};
